import MetaTags from "./index";

const tags = {
  vod: {
    title: "ログイン | スカパー！動画ストア",
    keywords: "スカパー！動画ストア,動画配信,ログイン",
    description: "スカパー！動画ストアへのログインはこちらから。",
    og: { type: "article" },
  },
};

export default function LoginMetaTags() {
  const props = tags["vod"];

  return <MetaTags {...props} />;
}
